import { SM } from 'src/assets/data/enum/storeModel.enum';

export const productionBase = {
  analyticsV2BaseUrl: '',
  themeConfig: {
    brand: 'xFarm',
    environmentName: 'prod',
    textName: 'xFarm',
    multifarm: true,
    sidebar: true,
    indexPage: '/auth/redirect',
    store: true,
    badgePRO: true,
    survey: true,
    welcomeUserCheck: true,
    welcomeFarmCheck: true,
    termsAndCondition: 'https://legal.xfarm.ag/#/terms-and-conditions?l=it&v=latest&b=xfarm',
    privacyPolicy: 'https://legal.xfarm.ag/#/privacy-policy?l=it&v=latest&b=xfarm',
    advEnable: true,
    activeSocial: [],
    enableForgotPassword: true,
    enableRegistration: true,
    enableLoginForm: true,
    enableSloganLogin: true,
    enableReCaptcha: true,
    versionPublicPage: 'v2',
    limitCropList: 5,
    enableVirtualField: false,
    forceHideFunctionalityList: [
      SM.SM_ANALYTICS_SUSTAINABILITY,
      SM.SM_ANALYTICS_IMPACT,
      SM.SM_ANALYTICS_REGENERATIVE,
      SM.SM_ANALYTICS_OVERVIEW,
      SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
      SM.SM_CONTRACT_AUDIT,
      SM.SM_EDUCATION_EDITOR,
      SM.SM_CROP_MAP,
      SM.SM_FARM_DOSSIER,
    ],
    // If empty the user can select all the languages available
    // If not empty the user can select only the languages in the array
    availableLanguages: [],
    showVatInSignUpPage: false,
    legalModeBySaas: false,
    showQRCodeContainer: true,
    defaultOpenCreateFieldCollapse: false,
    showTelemetryView: false,
    defaultUIMode: 'FARM',
    chatServiceProvider: 'salesforce',
    iOSAPPIDCode: '1468992158',
    downlaodAPPUrl: 'https://rebrand.ly/DownloadxFarm',
    storewebAppUrl: 'https://xfarm.ag/versioni-e-prezzi',
    newsSidebarTabActivation: true,
    forcedDefaultLang: null,
    isIsoTaskDevMode: false,
    alarmViewMode: 'card',
    checkActiveAlarm: 'byActiveBool',
    hideMultifarmSelector: false,
    alertPushSelectionEnable: true,
    documentViewTypeEnable: ['certification', 'security', 'insurance'],
    enableMultifarmButtonDelete: true,
    auditTabEnabled: [],
    enabledSettingsTabs: [], // All enabled if empty
    enableRedeemCouponPage: false,
    enableUserManagement: true,
    isAnalyticsMode: false,
    forceShowFunctionalityList: [], //module to show if isAnalyticsMode == true
    showTotHaWorkplace: true,
    showYaraNPK: true,
    sideBarItemsOverride: {},
  },
  local: false,
  production: true,
  enableTranslateMode: false,
  palette: {
    '--p-xfarm-50': '#dee8de',
    '--p-xfarm-100': '#bed1be',
    '--p-xfarm-200': '#9eba9f',
    '--p-xfarm-300': '#7fa480',
    '--p-xfarm-400': '#608E63',
    '--p-xfarm-500': '#567f59',
    '--p-xfarm-600': '#4d704f',
    '--p-xfarm-700': '#446145',
    '--p-xfarm-800': '#3b533c',
    '--p-xfarm-900': '#324633',
    '--p-xfarm-950': '#29382a',
  },
  primary: '#608e63',
  primaryOpacity: '#7caa81',
  primaryOpacity15: '#E7EEE8',
  secondary: '#517753',
  textColorNav: '#FFFFFF',
  textColorHeaderTable: '#FFFFFF',
  textLoginVersion: '#777777',
  btnSuccess: '#608e63',
  textBtnSuccess: '#FFFFFF',
  textBtnHover: '#FFFFFF',
  backgroundSplashScreen: '#608e63',
  spinnerSplashScreen: '#FFFFFF',
  navBarColor: '#608e63',
  colorSidebarHeader: '#517753',
  textColorSidebar: '#FFFFFF',
  apiBaseUrl: 'https://api-prod.xfarm.ag/',
  apiContractsUrl: 'https://api-contracts.xfarm.ag',
  activityServiceUrl: 'https://activity.xfarm.ag/',
  dossierServiceUrl: 'https://hubfarm-service-prod.xfarm.ag',
  productServiceUrl: 'https://api-product2.xfarm.ag/',
  apiAnalyticsUrl: 'https://api-analytics.xfarm.ag/',
  SSOfrontAppCallback: 'https://app.xfarm.ag/#/oauthCheck?token=',
  googleApiKey: 'AIzaSyDkngDoX2cn5nqFis2zEBmt-I7yq17r0hM',
  stripePublicApiKey: 'pk_live_XrvLbzLTkQDB8jfNAE6Opssm007yvD4Pbl',
  googleAnalyticsId: 'UA-112475645-1',
  launchDarklyKey: '66e146372d252f104d01a1fb',
  agrirouterFadeUrl: 'https://fade.xfarm.ag/',
  geoserverUrl: 'https://geoserver.xfarm.ag/geoserver/',
  isoTaskManagementServiceUrl: 'https://iso-task.xfarm.ag/',
  includeISOXML: true,
  showStaticMap: true,
  telemetryServiceUrl: 'https://telemetry.xfarm.ag/core/',
  telemetryMachineryUrl: 'https://telemetry.xfarm.ag/machinery/',
  telemetryUrlWS: 'wss://telemetry.xfarm.ag/',
  chatSFUrlSrevice: 'https://support.xfarm.ag/sf/index-chat.html',
  chatSlackUrlSrevice:
    'https://support.xfarm.ag/?x=KjYrDhVvDodUz-zYHtQ2BccEYyvmn-7PHF6FDia88NurLYxC-HZeJLddhMWb9uRuJQ',
  assetsUrl: 'https://cdn.xfarm.ag/webapp/xfarm/',
  publicAssetsUrl: 'https://cdn.xfarm.ag/',
  financeServiceUrl: 'https://api-finance.xfarm.ag/',
  commonServiceUrl: 'https://api-prod-common.xfarm.ag/',
  commonApiKey: '5323d47b-daac-4863-81db-13c93e01f90f',
  checksServiceUrl: 'https://api-rules-control-engine.xfarm.ag/',
  nutritionServiceUrl: 'https://api-crop-nutrition.xfarm.ag/',
  rationServiceUrl: 'https://api-ration.xfarm.ag/',
  surveyServiceUrl: 'https://api-xsurvey-prod.xfarm.ag/',
  regenerativeServiceUrl: 'https://api-xregenerative-prod.xfarm.ag/',
  connectionHubServiceUrl: 'https://api-connection-hub.xfarm.ag/',
  apiGatewayUrl: 'https://xapi.xfarm.ag/',
  weatherHubAssetsPath: 'https://storage.googleapis.com/iot-assets-bucket-c2b3352/weather-hub/',
  subscriptionServiceUrl: 'https://api-subscription.xfarm.ag/',
  cmsServiceUrl: 'https://cms.xfarm.ag',
  cmsApiKey:
    'f50dac34b36061089cd117aec30816f15e6a251134be2bbc61cb53f7c8fb6a932cc3235757165bf20301adae7d261cef5314d0a010b6aa38814a1b3320d8b6c1cf7fa8ecb1078246aa14dec2a39153043666b91356a981c1f3e701610ac01b2cffdd08560e9868530fa9cd5ddb83b5bac77d20a991d1918787c20ba46e3961f5',
  postHogEnabled: false,
  eventTrackingEndpoint: 'https://prd-sts.xfarm.ag',
  postHogKey: '',
  apiJobUrl: 'https://api-job.xfarm.ag/',
};
